// removed by extract-text-webpack-plugin
module.exports = {"logo":"TGqjuUXoG8IoApcQ0GEvM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Logo/Logo.css
// module id = 28
// module chunks = 0